import { preact, $$ } from "../../Core/References";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";
import { DataType } from "../SharedEnums/SharedEnums";


export interface IDataLabelProps extends IDataControlProps
{
    Content?: string;
    Type?: DataType;
    Prefix?: string;
    ShowMoreHeight?: number;
}

export class DataLabel extends DataControl<IDataLabelProps>
{
    public override Container: HTMLSpanElement;
    private _lblContent: HTMLElement;
    private _lnkShowMore: HTMLAnchorElement;

    constructor(props)
    {
        super(props);
    }

    public setValue(value: string)
    {
        if (value == null)
        {
            this.hide();
        }

        if (this.props.Type === DataType.Html)
        {
            this._lblContent.innerHTML = value;
            return;
        }

        let strValue: string;

        switch (this.props.Type)
        {
            case DataType.FlexDate:
                strValue = $$.formatFlexDate(value);
                break;
            default:
                strValue = value?.toString() || "";

        }
        $(this._lblContent).text((this.props.Prefix || "") + strValue);
        this.show();
    }

    public getValue()
    {
        return null;
    }

    public getText()
    {
        return null;
    }

    public focus()
    {
        $$.focus(this.Container);
    }

    public resetShowMore()
    {
        if (this.props.ShowMoreHeight)
        {
            this._removeShowMore();
            if (this.Container.clientHeight > this.props.ShowMoreHeight)
            {
                this.Container.style.maxHeight = this.props.ShowMoreHeight + "px";
                this.Container.style.overflow = "hidden";
                $$.show(this._lnkShowMore);
            }
        }
    }

    public override componentDidUpdate()
    {
        this.resetShowMore();
    }

    private _removeShowMore()
    {
        this.Container.style.maxHeight = "";
        this.Container.style.overflow = "";
        $$.hide(this._lnkShowMore);
    }

    private _onLnkShowMoreClick()
    {
        this._removeShowMore();
    }

    public render(props: IDataLabelProps)
    {
        if (props.ShowMoreHeight) 
        {
            return (<div ref={(ref) => this._registerContainer(ref)} style={{ position: "relative" }}>
                {
                    props.Type === DataType.Html?
                        (<span ref={(ref) => this._lblContent = ref} dangerouslySetInnerHTML={{ __html: props.Content }}></span>) :
                        (<span ref={(ref) => this._lblContent = ref}>{props.Content || null}</span>)
                }
                <a ref={(ref) => this._lnkShowMore = ref} className="showMore" href="javascript:void(0)" onClick={this._onLnkShowMoreClick.bind(this)}> Show more</a>
            </div>);
        }
        else
        {
            return (<span ref={(ref) => { this._registerContainer(ref); this._lblContent = ref; }} >{props.Content}</span>);
        }
    };
}
